module.exports = __webpack_public_path__ + "img/file-earmark-check.ce73483f.svg";